import { h as __h } from "preact";
import { Component } from "preact";
import { orgResponse } from "~/backend/validate.js";
import { ApiError, authedApiRequest, response } from "~/lib/api.js";
import { alert } from "~/util/alert.js";
import html from "~/util/html.js";
import { PromiseSignal } from "~/util/promise.js";
import { object, parse, string } from "~/util/validate.js";
import Button from "~/component/Button.js";
import Field from "~/component/Field.js";
import Section from "~/component/Section.js";
import { Crumb } from "~/admin/component/Breadcrumbs.js";
import EnforcedPolicies from "./EnforcedPolicies.js";
import adminStyle from "~/admin/lib/style.js";
import input from "~/style/input.js";
import { adopt, importCss, CSS_MODULE_SCRIPTS } from "~/util/css.js";
const {
  default: sheet
} = CSS_MODULE_SCRIPTS ? await import("./Settings.module.css", {
  with: {
    type: "css"
  }
}) : await importCss("./Settings.module.css", import.meta.url);
const css = adopt(sheet);

/**
 * @extends Component<Props>
 *
 * @typedef {object} Props
 * @property {orgResponse} org
 */
export default class Settings extends Component {
  updateOrg = new PromiseSignal(/** @param {SubmitEvent & { currentTarget: HTMLFormElement }} ev */async ev => {
    ev.preventDefault();
    const form = new FormData(ev.currentTarget);
    const body = parse(object({
      name: string
    }), Object.fromEntries(form.entries()));
    const {
      data
    } = await authedApiRequest("PATCH", `/v2/orgs/${this.props.org.id}`, {
      json: {
        name: body.name
      },
      schema: response(orgResponse)
    });
    alert(`Updated organization '${data.name}'`, {
      type: "success"
    });
  });
  render() {
    const error = this.updateOrg.error && ApiError.from(this.updateOrg.error);
    return [__h(Crumb, {}, "Settings"), __h("div", {
      "class": adminStyle.main
    }, __h("div", {
      "class": css.body
    }, __h(Section, {
      title: "Organization",
      icon: "office"
    }, __h("form", {
      "class": css.form,
      onSubmit: this.updateOrg.invoke
    }, __h(Field, {
      "for": "org_name",
      label: "Organization name"
    }, __h("input", {
      "class": input.input,
      id: "org_name",
      defaultValue: this.props.org.name,
      name: "name",
      required: true,
      minlength: 2,
      maxlength: 100
    })), __h("div", {
      "class": css.actions
    }, __h("p", {
      "class": css.error
    }, error?.message), __h(Button, {
      type: "submit",
      loading: this.updateOrg.loading
    }, "Update organization")))), __h(EnforcedPolicies, {
      org: this.props.org
    })))];
  }
}